import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {
  OrderRequestCancellationCodeModel
} from "../../models/order-request-cancellation-code-model";
import {Observable} from "rxjs";
import {ResponseCancellationModel} from "../../models/response-cancellation-model";
import {OrderRequestCancellationCodeResultModel} from "../../models/order-request-cancellation-code-result-model";
import {
  AccountDeletionConfirmModel,
  AccountDeletionRequestCodeModel
} from "../../models/account-deletion-request-code-model";
import {ResponseDeletionModel} from "../../models/response-deletion-model";
import {AccountDeletionCodeResultModel} from "../../models/account-deletion-code-result-model";
import * as moment from 'moment';
import {keyframes} from "@angular/animations";

@Injectable({
  providedIn: "root"
})
export class AccountDeletionService {

  readonly apiPath = "account-deletion/";
  readonly headers = new HttpHeaders({"No-Auth": "True"});

  constructor(
    private http: HttpClient,
  ) {
  }


  submitDeletionDetails(model: AccountDeletionRequestCodeModel): Observable<any> {
    return this.http.post(this.apiPath + "cancellation-details", model, {headers: this.headers});
  }

  requestDeletion(phone: number, dob: Date): Observable<ResponseDeletionModel> {
    let dt = moment(dob);
    return this.http.post(this.apiPath, {
      phone,
      dob: dt.toISOString(true),
    }, {headers: this.headers}) as Observable<ResponseDeletionModel>;
  }

  requestDeletionVerificationCode(phone: number, dob: Date): Observable<any> {
    let dt = moment(dob);
    return this.http.post(this.apiPath + "request-code", {
      phone,
      dob: dt.toISOString(true),
    }, {headers: this.headers});
  }

  verifyDeletionVerificationCode(model: AccountDeletionRequestCodeModel): Observable<string> {
    return this.http.post(this.apiPath + "verify-code", {
      phone: model.phone,
      dob: moment(model.dob).toISOString(true),
      code: model.code,
    }, {headers: this.headers}) as Observable<string>;
  }

  confirmDeletion(model: AccountDeletionConfirmModel): Observable<AccountDeletionCodeResultModel> {
    return this.http.post(this.apiPath + "confirm", {
      phone: model.phone,
      dob: moment(model.dob).toISOString(true),
      code: model.code,
      deleteDataRequest: model.deleteDataRequest,
    }, {headers: this.headers}) as Observable<AccountDeletionCodeResultModel>;
  }
}
